import React, { useState } from 'react';

const MOCK_RESULTS = [
  { nome: 'PAC', prazo: 7, valor: 18.90, codigo: '03298' },
  { nome: 'SEDEX', prazo: 2, valor: 34.50, codigo: '03220' },
  { nome: 'Mini Envios', prazo: 10, valor: 12.40, codigo: '04227' },
  { nome: 'SEDEX 12', prazo: 1, valor: 52.80, codigo: '03140' },
];

export default function FreightCalculator() {
  const [form, setForm] = useState({ cepOrigem: '', cepDestino: '', peso: '' });
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const set = (f, v) => {
    setForm((prev) => ({ ...prev, [f]: v }));
    setErrors((e) => ({ ...e, [f]: undefined }));
  };

  function validate() {
    const errs = {};
    const cepRe = /^\d{5}-?\d{3}$/;
    if (!cepRe.test(form.cepOrigem)) errs.cepOrigem = 'CEP inválido';
    if (!cepRe.test(form.cepDestino)) errs.cepDestino = 'CEP inválido';
    if (!form.peso || Number(form.peso) <= 0) errs.peso = 'Informe o peso';
    return errs;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    setResults(null);
    // Demo: simula chamada com timeout (sem API Key em contexto público)
    setTimeout(() => {
      const sorted = [...MOCK_RESULTS].sort((a, b) => a.valor - b.valor);
      setResults(sorted);
      setLoading(false);
    }, 1200);
  }

  return (
    <div style={styles.wrap}>
      <form onSubmit={handleSubmit} noValidate style={styles.form}>
        <div style={styles.fields}>
          <div style={styles.field}>
            <label style={styles.label}>CEP de Origem</label>
            <input
              style={{ ...styles.input, ...(errors.cepOrigem ? styles.inputErr : {}) }}
              value={form.cepOrigem}
              onChange={(e) => set('cepOrigem', e.target.value)}
              placeholder="00000-000"
              maxLength={9}
            />
            {errors.cepOrigem && <span style={styles.err}>{errors.cepOrigem}</span>}
          </div>

          <div style={styles.field}>
            <label style={styles.label}>CEP de Destino</label>
            <input
              style={{ ...styles.input, ...(errors.cepDestino ? styles.inputErr : {}) }}
              value={form.cepDestino}
              onChange={(e) => set('cepDestino', e.target.value)}
              placeholder="00000-000"
              maxLength={9}
            />
            {errors.cepDestino && <span style={styles.err}>{errors.cepDestino}</span>}
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Peso (gramas)</label>
            <input
              style={{ ...styles.input, ...(errors.peso ? styles.inputErr : {}) }}
              type="number"
              min="1"
              value={form.peso}
              onChange={(e) => set('peso', e.target.value)}
              placeholder="500"
            />
            {errors.peso && <span style={styles.err}>{errors.peso}</span>}
          </div>
        </div>

        <button type="submit" disabled={loading} style={styles.btn}>
          {loading ? 'Calculando...' : 'Calcular Frete Grátis'}
        </button>
      </form>

      {loading && (
        <div style={styles.loadingWrap}>
          <div style={styles.loadingDots}>
            <span style={{ ...styles.dot, animationDelay: '0s' }} />
            <span style={{ ...styles.dot, animationDelay: '0.15s' }} />
            <span style={{ ...styles.dot, animationDelay: '0.3s' }} />
          </div>
          <p style={styles.loadingText}>Consultando transportadoras...</p>
        </div>
      )}

      {results && (
        <div style={styles.results}>
          <p style={styles.resultsTitle}>
            ✅ {results.length} opções disponíveis para esta rota
          </p>
          <div style={styles.cards}>
            {results.map((r, i) => (
              <div key={r.codigo} style={{ ...styles.card, ...(i === 0 ? styles.cardBest : {}) }}>
                {i === 0 && <span style={styles.bestBadge}>Mais barato</span>}
                <div style={styles.cardName}>{r.nome}</div>
                <div style={styles.cardPrice}>
                  {r.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </div>
                <div style={styles.cardPrazo}>{r.prazo} dia{r.prazo !== 1 ? 's' : ''} úteis</div>
              </div>
            ))}
          </div>
          <p style={styles.disclaimer}>
            * Valores simulados para demonstração. Contrate um plano para valores reais.
          </p>
        </div>
      )}

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-8px); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  fields: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px',
  },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: '500', color: '#374151' },
  input: {
    padding: '11px 14px',
    border: '1.5px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    fontFamily: 'inherit',
    transition: 'border-color 0.15s',
    background: '#f9fafb',
  },
  inputErr: { borderColor: '#dc2626', background: '#fef2f2' },
  err: { fontSize: '11px', color: '#dc2626' },
  btn: {
    padding: '13px',
    background: 'linear-gradient(135deg, #f97316, #ea580c)',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: 'inherit',
    letterSpacing: '0.2px',
  },
  loadingWrap: { textAlign: 'center', padding: '24px 0' },
  loadingDots: { display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: '10px' },
  dot: {
    width: '8px', height: '8px',
    background: '#1e40af',
    borderRadius: '50%',
    display: 'inline-block',
    animation: 'bounce 0.6s infinite',
  },
  loadingText: { fontSize: '14px', color: '#6b7280' },
  results: { marginTop: '20px' },
  resultsTitle: { fontSize: '14px', fontWeight: '600', color: '#16a34a', marginBottom: '12px' },
  cards: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' },
  card: {
    border: '1.5px solid #e5e7eb',
    borderRadius: '10px',
    padding: '14px',
    textAlign: 'center',
    position: 'relative',
    background: '#fff',
  },
  cardBest: { borderColor: '#2563eb', background: '#eff6ff' },
  bestBadge: {
    position: 'absolute', top: '-10px', left: '50%', transform: 'translateX(-50%)',
    background: '#2563eb', color: '#fff',
    fontSize: '10px', fontWeight: '700',
    padding: '2px 10px', borderRadius: '10px',
    textTransform: 'uppercase', letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
  },
  cardName: { fontSize: '13px', fontWeight: '600', color: '#111827', marginBottom: '6px' },
  cardPrice: { fontSize: '20px', fontWeight: '700', color: '#1e40af', marginBottom: '4px' },
  cardPrazo: { fontSize: '12px', color: '#6b7280' },
  disclaimer: { fontSize: '11px', color: '#9ca3af', marginTop: '10px', textAlign: 'center' },
};
